export default {
  parse (input) {
    let [sellingCompanyCode, ...rest] = input.split('-')
    return {
      sellingCompanyCode,
      bookingId: rest.join('-'),
    }
  },
  stringify ({sellingCompanyCode, bookingId}) {
    return `${sellingCompanyCode}-${bookingId}`
  },
}
